import { Component, input } from '@angular/core';

@Component({
  selector: 'skeleton-item',
  standalone: true,
  template: `<div class="skeleton-item" [style.height]="height()" [style.width]="width()"></div>`,
  styleUrls: ['./skeleton-item.component.scss']
})
export class SkeletonItemComponent {
  height = input('20px');
  width = input('100%');
}
